(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cerlume-combinations"] && !Shopify.designMode) return;
  try {
    
(() => {
  function initCombinations(root) {
    root.querySelectorAll('[data-cerlume-combinations]').forEach(section => {
      if (section.dataset.ready) return;
      section.dataset.ready = 'true';
      const tabs = Array.from(section.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(item => {
          const active = item === tab;
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !active;
        });
        if (focus) tab.focus();
      }
      tabs.forEach((tab, index) => {
        tab.addEventListener('click', () => select(tab, false));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          else if (event.key === 'ArrowLeft') next = (index + tabs.length - 1) % tabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = tabs.length - 1;
          if (next !== undefined) { event.preventDefault(); select(tabs[next], true); }
        });
      });
      section.querySelectorAll('.ccb-panel').forEach(panel => {
        panel.querySelectorAll('[data-ccb-select]').forEach(button => {
          button.addEventListener('click', () => {
            const selected = button.dataset.ccbSelect;
            panel.querySelectorAll('[data-ccb-variant]').forEach(view => { view.hidden = view.dataset.ccbVariant !== selected; });
            panel.querySelectorAll('[data-ccb-select]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
          });
        });
      });
      section.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[role="tabpanel"]');
        if (panel) {
          const tab = document.getElementById(panel.getAttribute('aria-labelledby'));
          if (tab) select(tab, false);
        }
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initCombinations(document));
  else initCombinations(document);
  document.addEventListener('shopify:section:load', event => initCombinations(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["toggle-function-product"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    const thumb = event.target.closest('[data-cer-elec-view]');
    if (thumb) {
      const root = thumb.closest('.cer-elec');
      const main = root.querySelector('.cer-elec-main');
      main.removeAttribute('srcset');
      main.src = thumb.getAttribute('data-cer-elec-view');
      main.alt = thumb.getAttribute('data-cer-elec-alt');
      main.closest('.cer-electric-media').style.cssText = thumb.querySelector('.cer-electric-media').style.cssText;
      root.querySelectorAll('[data-cer-elec-view]').forEach(button => button.setAttribute('aria-pressed', String(button === thumb)));
    }
    const catalogue = event.target.closest('[data-cer-elec-catalogue]');
    if (catalogue) catalogue.closest('.cer-elec').querySelector('[data-cer-elec-catalogue-input]').checked = true;
  });

  } catch(e) { console.error(e); }
})();
})();
